exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".hero-b81b51b1{height:auto;min-height:120px}.padded-ad22dab0{padding:20px 20px}\n", ""]);

// Exports
exports.locals = {
	"hero": "hero-b81b51b1",
	"padded": "padded-ad22dab0"
};